<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container mt-4 mb-4'">
    <div class="mt-2" style="max-width:597px">
        <h3>Rediger kategori</h3>
        <br/>
        <div>
          <span class="ingredient-title">Navn</span>
          <input id="name" class="form-control" type="text" v-model="category.name"/>
        </div>

        <div class="mb-4">
          <span class="ingredient-title">Hva skal kategorien inneholde?</span>
          <select class="form-select" v-model="category.itemType" :disabled="itemTypeLocked">
            <option value="">Velg type</option>
            <option value="DISH">Matrett</option>
            <option value="DRINK_BUBBLE_TEA">Bubble tea</option>
            <option value="DRINK">Drikke UTEN alkohol</option>
            <option value="DRINK_ALCOHOL">Drikke MED alkohol</option>
            <option value="ADD_ON">Tilbehør</option> <!-- itemType ADD_ON for item in category -->
            <option v-if="offerDeliveryService" value="DELIVERY_SERVICE">Leveringstjeneste</option>
          </select>
          <div v-if="itemTypeLocked" class="text-muted small mt-1">
            <i class="fas fa-lock me-1"></i>
            Låst fordi kategorien inneholder {{ itemCountText }}. Typen bestemmer hva nye produkter blir,
            mens produktene som allerede ligger her beholder sin egen — endres den nå, peker kategorien og
            innholdet hver sin vei. Flytt eller slett produktene først, eller lag en ny kategori.
          </div>
        </div>

        <div v-if="hasMultiLocations()">
          <span class="ingredient-title">Tilgjengelig på følgende avdelinger</span>
          <fieldset>
            <label v-for="(location, index) in locations" :key="index" class="multiple-checkbox-label">
              <input type="checkbox" :name="location.name" :value="location.id" @click="setSelectedLocations" class="multiple-checkbox"
                     :checked="category.availableAtLocationIds.indexOf(location.id) > -1" /> {{ location.name }}
            </label>
          </fieldset>
        </div>

      <div v-if="showAvailableForChannels()">
        <span class="ingredient-title">Tilgjengelig på følgende kanaler</span>
        <fieldset>
          <label v-for="(channel, index) in channels" :key="index" class="multiple-checkbox-label">
            <input type="checkbox" :name="channel.name" :value="channel.id" @click="setSelectedChannels" class="multiple-checkbox"
                   :checked="category.availableForChannelIds.indexOf(channel.id) > -1" /> {{ channel.name }}
          </label>
        </fieldset>
      </div>

        <div v-if="showAvailableForOrderTypes()">
          <span class="ingredient-title">Tilgjengelig for</span>
          <fieldset>
            <label v-for="(orderType, index) in orderTypes" :key="index" class="multiple-checkbox-label">
              <input type="checkbox" :name="orderType" :value="orderType" @click="setSelectedOrderTypes" class="multiple-checkbox"
                     :checked="category.availableForOrderTypes.indexOf(orderType) > -1" /> {{ getOrderTypeName(orderType) }}
            </label>
          </fieldset>
        </div>

        <div v-if="showAvailableOnDays()">
          <span class="ingredient-title">Tilgjengelig på følgende dager</span>
          <fieldset>
            <label v-for="(day, index) in days" :key="index" class="multiple-checkbox-label">
              <input type="checkbox" :name="day" :value="day" @click="setSelectedDays" class="multiple-checkbox"
                     :checked="category.availableOnDays.indexOf(day) > -1" /> {{ getDayName(day) }}
            </label>
          </fieldset>
        </div>

      <div class="mt-4">
          <div class="bo_label">Bilde</div>
          <div style="margin-top: -10px">Dette kategoribildet vises bare i selvbetjeningskiosk og kasse.</div>
          <div class="mt-4 mb-4">
            <img :src="category.imageUrl" width="150" height="150" class="mb-2" />
          </div>
          <div class="mt-4 mb-4">
            <input type="file" class="form-control" accept="image/png,image/jpeg,image/avif,image/webp" ref="file" @change="selectFile" />
          </div>
        </div>

        <div>
          <span class="bo_label">Beskrivelse</span>
          <textarea id="description" class="form-control" type="text" v-model="category.description" rows="3" cols="50"></textarea>
        </div>

        <div v-if="!allLocationsUseManualPickupTime && category.itemType && category.itemType != 'DELIVERY_SERVICE'" class="mt-4 mb-4 p-3 border rounded bg-body-tertiary">
          <span class="ingredient-title">Sett tilberedningstid for alle produkter i denne kategorien</span>
          <p class="text-muted small">Oppdaterer tilberedningstiden for alle produkter i denne kategorien. Tilberedningstiden brukes til smartere beregning av hentetid.</p>
          <div class="d-flex align-items-end gap-2">
            <div>
              <input type="number" class="form-control" min="0" v-model.number="bulkPrepTimeMinutes" placeholder="Minutter" style="max-width: 150px;" />
            </div>
            <button type="button" class="bo_btn" @click="setPrepTimeForCategory" :disabled="bulkPrepTimeMinutes === null || bulkPrepTimeMinutes === ''">
              Sett for alle
            </button>
          </div>
          <div class="mt-2">
            <label style="display: flex; align-items: center; gap: 8px;">
              <input type="checkbox" v-model="bulkReadyMade" style="width: 22px; height: 22px;" />
              Hyllevare/Ferdiglaget (f.eks. brus — påvirkes ikke av kjøkkenkø)
            </label>
          </div>
          <div v-if="bulkPrepTimeMessage" class="mt-2 small" :class="bulkPrepTimeSuccess ? 'text-success' : 'text-danger'">{{ bulkPrepTimeMessage }}</div>
        </div>

        <div v-if="!panelMode" class="bo_hr mt-4">
          <hr/>
        </div>

        <div v-if="!panelMode" class="mb-5">
          <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveCategory"> Lagre </button>
          <button v-else type="button" class="bo_btn" @click="saveCategory" disabled="true"> Lagre </button>
        </div>
    </div>
    <div v-if="panelMode" class="panel-sticky-footer">
      <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveCategory"> Lagre </button>
      <button v-else type="button" class="bo_btn" @click="saveCategory" disabled="true"> Lagre </button>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ProductService from "@/services/product/ProductService";
import MediaFileService from "@/services/media/MediaFileService";
import ImageCompressor from "@/util/ImageCompressor";
import LocationUtil from "@/util/LocationUtil";
import ChannelUtil from "@/util/ChannelUtil";
import MerchantUtil from "@/util/MerchantUtil";

export default {
  components: {LoadingSpinner},
  props: {
    panelMode: { type: Boolean, default: false },
    categoryIdProp: { type: String, default: '' }
  },
  emits: ['saved'],
  data() {
    return {
      loading: true,

      channels: ChannelUtil.CHANNELS, //one list with the channel line and filter on /products
      locations: [],
      days: ["MONDAY", "TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY","SUNDAY"],
      categoryId: '',
      imageFile: undefined,
      bulkPrepTimeMinutes: null,
      bulkReadyMade: false,
      bulkPrepTimeMessage: '',
      bulkPrepTimeSuccess: false,
      // True only while the loaded document is being copied into the form. The itemType watcher below
      // constrains the order types when a PERSON picks a different type, and must stay out of the way
      // while the form is simply being filled in from what was saved.
      applyingLoadedCategory: false,
      //True while the ticks on screen were imposed by the chosen type rather than picked by a
      //person. A category loaded from the database carries what someone saved, so it starts false.
      orderTypesForcedByType: false,
      //How many products the category holds. null = not established yet (still loading, or the lookup
      //failed) — the type stays editable then, because locking on a guess would block a legitimate edit.
      itemCount: null,
      category: {
        type: "category",
        merchant: "",
        sortOrder: -1,
        name: "",
        availableAtLocationIds: [],
        availableForChannelIds: [],
        availableForOrderTypes: [],
        availableOnDays: [],
        imageUrl: "",
        description: "",
        showItemsCount: true,
        itemType: ""
      }
    };
  },
  mounted() {
    if(MerchantUtil.showAvailableOnDaysHolidayOption()){
      this.days.push("HOLIDAY");
    }

    this.categoryId = this.categoryIdProp || this.$route.query.categoryId;
    console.log("CategoryEdit opened - categoryId: " + this.categoryId);
    //Decides whether the type stays editable — see itemTypeLocked. Separate from the call below so a
    //failure here only leaves the type editable, never blocks the form from loading.
    ProductService.getItemsOfCategory(this.categoryId).then(
        (response) => {
          this.itemCount = Array.isArray(response.data) ? response.data.length : 0;
        },
        (error) => {
          console.log(error);
        }
    );

    ProductService.getDataForCategoryAdminGui(this.categoryId).then(
        (response) => {
          let dataForGui = response.data;
          //console.log("dataForGui: " +  JSON.stringify(dataForGui));

          this.locations = dataForGui.locations;
          this.applyingLoadedCategory = true;
          this.category = dataForGui.category;
          if(this.category.availableAtLocationIds === undefined){
            this.category.availableAtLocationIds = []; //init it
          }
          if(this.category.availableForChannelIds === undefined){
            this.category.availableForChannelIds = ['POS', 'KIOSK', 'WEB_DINE_IN', 'WEB_TAKEAWAY']; //old data fix
          }
          if(this.category.availableForOrderTypes === undefined){
            //Old data fix, and now load-bearing: the itemType watcher used to set this field on every
            //open, which hid the fact that it was never initialised here. It no longer does, so a
            //document saved before the field existed would leave the template calling .indexOf on
            //undefined. Default to the same constraint a new category of this type would get.
            this.category.availableForOrderTypes = this.defaultOrderTypesFor(this.category.itemType);
          }
          if(this.category.availableOnDays === undefined){
            this.category.availableOnDays = []; //init it
          }

          //Cleared after the watchers queued by the assignment above have run.
          this.$nextTick(() => { this.applyingLoadedCategory = false; });

          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  computed: {
    /**
     * The type may only be changed while the category is EMPTY.
     *
     * It is not retroactive: ItemCreate copies category.itemType onto each new product, while products
     * already saved keep the type they were created with. So changing it on a category that holds
     * products splits the two apart — the category can end up marked "Drikke MED alkohol", and therefore
     * dine-in only, while its products are still dishes with takeaway prices and takeaway availability.
     * Nothing reports that; it simply sells wrong.
     *
     * Emptying the category lifts the lock: getItemsOfCategory already excludes soft-deleted products.
     */
    itemTypeLocked(){
      return this.itemCount > 0;
    },
    itemCountText(){
      return this.itemCount === 1 ? '1 produkt' : this.itemCount + ' produkter';
    },
    orderTypes(){
      if(this.category.itemType == "DRINK_ALCOHOL"){
        return ['DINE_IN']; //Alcoholic drinks can only be ordered for dine-in
      } else if(this.category.itemType == "DELIVERY_SERVICE"){
        return ['TAKEAWAY']; //Delivery service is only for takeaway/delivery
      } else {
        return ['DINE_IN', 'TAKEAWAY'];
      }
    },
    activateSaveButton(){
      if(this.category.name.length > 0 && this.category.itemType.length > 0){
        return true;
      } else {
        return false;
      }
    },
    offerDeliveryService(){
      //True if any location offers delivery (offerDeliveryService is now per-location).
      return this.locations.some(location => location.offerDeliveryService);
    },
    allLocationsUseManualPickupTime(){
      //Prep time is only used by the smart pickup time calculation, so the bulk
      //prep time feature is hidden when every location uses manual pickup/delivery time.
      return this.locations.length > 0 && this.locations.every(location => location.useManualPickupOrDeliveryTime === true);
    }
  },
  watch: {
    /**
     * Picking a different type re-decides which order types are possible: alcohol is dine-in only,
     * a delivery service is takeaway only, anything else can be both.
     *
     * It must NOT run while the form is being filled in from the saved document. Loading assigns
     * category.itemType from "" to its real value, which looked exactly like a person changing the
     * type — so every open silently replaced the saved "Tilgjengelig for" with the default. The ticks
     * therefore never appeared to change, and worse: saving ANY edit afterwards wrote the default back
     * over a deliberate restriction, so a takeaway-only category quietly became dine-in too.
     */
    'category.itemType'(newValue) {
      if(this.applyingLoadedCategory){
        return;
      }
      const required = this.requiredOrderTypesFor(newValue);
      if(required){
        this.category.availableForOrderTypes = required;
        this.orderTypesForcedByType = true;
        return;
      }
      //Unconstrained: both order types are only a DEFAULT for a fresh form, so it must not overwrite a
      //deliberate choice. Picking "Tilgjengelig for" BEFORE "Hva skal kategorien inneholde" used to
      //reset the ticks — choose dine-in only, then choose Matrett, and takeaway came back on. Apply the
      //default only when there is nothing worth keeping: an empty selection, or one a previous
      //restriction imposed rather than the user picking it (so switching away from alcohol does not
      //silently leave the category dine-in only).
      if(this.orderTypesForcedByType || this.category.availableForOrderTypes.length === 0){
        this.category.availableForOrderTypes = ['DINE_IN', 'TAKEAWAY'];
      }
      this.orderTypesForcedByType = false;
    }
  },
  methods: {
    /**
     * The order types a category of this type is RESTRICTED to, or null when the type imposes no
     * restriction. Only a real restriction may overrule what the user ticked.
     */
    requiredOrderTypesFor(itemType){
      if(itemType === "DRINK_ALCOHOL"){
        return ['DINE_IN'];        //alcohol cannot be sold as takeaway
      }
      if(itemType === "DELIVERY_SERVICE"){
        return ['TAKEAWAY'];       //a delivery fee is never a dine-in line
      }
      return null;                 //anything else can be sold as either — the user decides
    },
    /** What a category of this type gets when nothing has been chosen — the restriction, or both. */
    defaultOrderTypesFor(itemType){
      return this.requiredOrderTypesFor(itemType) || ['DINE_IN', 'TAKEAWAY'];
    },
    getOrderTypeName(orderType){
      if(orderType === 'DINE_IN'){
        return 'Spise Her';
      } else if(orderType === 'TAKEAWAY'){
        return 'Takeaway';
      }
    },
    selectFile(){
      let file = this.$refs.file.files[0];
      ImageCompressor.compressImageToWebp(file).then((compressed) => {
        this.imageFile = compressed;
        console.log("imageFile: " + this.imageFile.name);
      }).catch((error) => {
        console.log("Image compression failed, using original: " + error.message);
        this.imageFile = file;
      });
    },
    hasMultiLocations(){
      return LocationUtil.hasMultiLocations();
    },
    showAvailableForChannels(){
      if(MerchantUtil.useFunctionality() === 'POS' || MerchantUtil.useFunctionality() === 'KIOSK_TAKEAWAY' || MerchantUtil.useFunctionality() === 'ALL' || MerchantUtil.websiteShowDineInMenu()){
        return true;
      }else {
        return false;
      }
    },
    showAvailableForOrderTypes(){
      if(MerchantUtil.useFunctionality() === 'POS' || MerchantUtil.useFunctionality() === 'KIOSK_TAKEAWAY' || MerchantUtil.useFunctionality() === 'ALL' || MerchantUtil.websiteShowDineInMenu()){
        return true;
      }else {
        return false;
      }
    },
    showAvailableOnDays(){
      return MerchantUtil.showAvailableOnDays();
    },
    setSelectedLocations(event){
      //console.log(JSON.stringify(this.category.availableAtLocationIds));
      let locationId = event.target.value;
      if(event.target.checked){
        this.category.availableAtLocationIds.push(locationId);
      } else {
        for (let i=0; i < this.category.availableAtLocationIds.length; i++){
          if (this.category.availableAtLocationIds[i] === locationId) {
            this.category.availableAtLocationIds.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.availableAtLocationIds));
    },
    setSelectedChannels(event){
      //console.log(JSON.stringify(this.category.validForChannels));
      let channelId = event.target.value;
      if(event.target.checked){
        this.category.availableForChannelIds.push(channelId);
      } else {
        for (let i=0; i < this.category.availableForChannelIds.length; i++){
          if (this.category.availableForChannelIds[i] == channelId) {
            this.category.availableForChannelIds.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.validForChannels));
    },
    setSelectedOrderTypes(event){
      //Whatever is on screen from here on was chosen by a person, not imposed by the type.
      this.orderTypesForcedByType = false;
      //console.log(JSON.stringify(this.category.availableForOrderTypes));
      let orderType = event.target.value;
      if(event.target.checked){
        this.category.availableForOrderTypes.push(orderType);
      } else {
        for (let i=0; i < this.category.availableForOrderTypes.length; i++){
          if (this.category.availableForOrderTypes[i] === orderType) {
            this.category.availableForOrderTypes.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.availableForOrderTypes));
    },
    getDayName(day){
      if(day === 'MONDAY'){
        return 'Mandag';
      } else if(day === 'TUESDAY'){
        return 'Tirsdag';
      } else if(day === 'WEDNESDAY'){
        return 'Onsdag';
      } else if(day === 'THURSDAY'){
        return 'Torsdag';
      } else if(day === 'FRIDAY'){
        return 'Fredag';
      } else if(day === 'SATURDAY'){
        return 'Lørdag';
      } else if(day === 'SUNDAY'){
        return 'Søndag';
      } else if(day === 'HOLIDAY'){
        return 'Hellig dag';
      }
      return 'DAY_NOT_DEFINED';
    },
    setSelectedDays(event){
      //console.log(JSON.stringify(this.category.availableOnDays));
      let day = event.target.value;
      if(event.target.checked){
        this.category.availableOnDays.push(day);
      } else {
        for (let i=0; i < this.category.availableOnDays.length; i++){
          if (this.category.availableOnDays[i] === day) {
            this.category.availableOnDays.splice(i,1);
            break;
          }
        }
      }
      //console.log(JSON.stringify(this.category.availableOnDays));
    },
    saveCategory(){
      this.loading = true;

      this.category.categoryId = this.categoryId;
      if(this.imageFile){
        if(this.category.imageUrl){
          MediaFileService.removeImageFile(this.category.imageUrl).then(
              (response) => {
                if(response.data === "SUCCEEDED"){
                  this.uploadImageThenEditCategory();
                } else {
                  console.log("Removing image failed");
                }
                this.loading = false;
              },
              (error) => {
                console.log(error);
              }
          );
        } else {
          this.uploadImageThenEditCategory();
        }
      } else {
        this.editCategory(this.category);
      }
    },
    uploadImageThenEditCategory(){
      MediaFileService.uploadImageFile(this.imageFile).then(
          (response) => {
            let imageUrl = response.data;
            if(imageUrl){
              //console.log("imageUrl: " + imageUrl);
              this.category.imageUrl = imageUrl;
              this.editCategory(this.category);
            } else {
              console.log("Uploading image failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    },
    setPrepTimeForCategory(){
      this.bulkPrepTimeMessage = '';
      ProductService.setPrepTimeForCategory(this.categoryId, this.bulkPrepTimeMinutes, this.bulkReadyMade).then(
          (response) => {
            if(response.data === 'SUCCEEDED'){
              this.bulkPrepTimeSuccess = true;
              this.bulkPrepTimeMessage = 'Tilberedningstid satt til ' + this.bulkPrepTimeMinutes + ' min for alle produkter i kategorien.';
            } else {
              this.bulkPrepTimeSuccess = false;
              this.bulkPrepTimeMessage = 'Noe gikk galt. Prøv igjen.';
            }
          },
          (error) => {
            console.log(error);
            this.bulkPrepTimeSuccess = false;
            this.bulkPrepTimeMessage = 'Noe gikk galt. Prøv igjen.';
          }
      );
    },
    editCategory(category){
      console.log('category: ' + JSON.stringify(category));
      ProductService.editCategory(category).then(
          (response) => {
            let documentId = response.data;
            if(documentId){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Editing category failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>

<style scoped>
.panel-sticky-footer {
  position: sticky;
  bottom: 0;
  background-color: var(--bo-surface);
  border-top: 1px solid var(--bo-line);
  padding: 15px 20px;
  z-index: 10;
}
</style>
